import React from 'react'
import { withTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import Cards from './components/Cards'
import LineChart from './components/OverviewChart/Chart'
import AccountSummary from './components/AccountSummary'
import LoyalMetrics from './components/LoyaltyMetric/LoyalMetrics'
import ReviewOverview from './components/ReviewOverview/ReviewOverview'
import useMerchant from 'hooks/useMerchant'

export default withTranslation()(function Overview({ t }) {
  const { merchant } = useMerchant()

  return (
    <section className="w-full max-w-6xl mx-auto pb-10 flex flex-col gap-6">
      <header className="flex flex-wrap items-end justify-between gap-x-4 gap-y-2">
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold text-dark-blue">{t('overview.title')}</h1>
          <p className="text-sm text-secondary mt-1 truncate">
            {merchant?.name ? t('overview.subtitle_named', { name: merchant.name }) : t('overview.subtitle')}
          </p>
        </div>

        <p className="text-sm text-secondary whitespace-nowrap">{dayjs().format('ddd, D MMM YYYY')}</p>
      </header>

      <Cards />

      <LineChart />

      {/* items-stretch keeps the summary list and the donut card the same height
          even though their content lengths differ */}
      <div className="grid lg:grid-cols-2 gap-4 items-stretch">
        <AccountSummary />
        <LoyalMetrics />
      </div>

      <ReviewOverview />
    </section>
  )
})
